import React from "react"

interface Props {
    components: Array<React.ElementType>
    children: React.ReactNode
}

export function Compose({ components, children }: Props) {
    return (
        <>
            {components.reduceRight(
                (acc, Comp) => (
                    <Comp>{acc}</Comp>
                ),
                children
            )}
        </>
    )
}
